import { FacebookFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { cn } from "@btnet/utilities-core";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

interface IBTIconFacebookFilledProps extends IBTIconProps {
    isOnDark?: boolean;
}

export const BTIconFacebookFilled: FunctionComponent<IBTIconFacebookFilledProps> = (baseProps) => {
    const { isOnDark, ...iconProps } = baseProps;
    const [props] = useAntIcon(iconProps);

    return (
        <FacebookFilled
            {...props}
            className={cn("BTIconFacebookFilled", props.className, { isOnDark })}
        />
    );
};
